module.exports = __webpack_public_path__ + "static/media/popup_desktop.a439ec10.png";